import { useQuery } from "react-query";
import axios from "infra/http";
import { AcordoDetails } from "../typings";

function useAcordo(id: string) {
  return useQuery(
    [`/v1/acordo-${id}`],
    async () => {
      const res = await axios.get<AcordoDetails>(`/v1/acordo/${id}`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useAcordo;
